import styled, { keyframes } from 'styled-components'
import Modal from './Modal'
import { colors } from 'config/ui'
import { tokens } from '@arvoreeducacao/bonsai-ds'

const CONTENT_HEIGHT = 486

export const ModalStyled = styled(Modal)`
  width: 100%;
  max-width: 900px;
  padding-bottom: 80px;
  position: relative;
  > div {
    padding: 0;
    position: static;
  }

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    border-radius: 5px;
  }
`

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: stretch;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: row;
  }
`

export const Container = styled.div`
  text-align: center;
  color: ${colors.gray9};
  min-height: 188px;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    width: 50%;
    height: ${CONTENT_HEIGHT}px;
    text-align: left;
  }
`
export const ContainerCenter = styled.div`
  height: auto;
`

export const ContainerInfos = styled(Container)`
  padding: 0 ${tokens.spacing.insetMedium}px;
  height: ${CONTENT_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  overflow-y: auto;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    padding: ${tokens.spacing.spacing_56}px ${tokens.spacing.spacing_48}px 0;
  }
`

export const Title = styled.h3`
  font-size: 22px;
  margin: 10px auto 16px;
  color: ${colors.gray9};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    font-size: 30px;
  }
`

export const Description = styled.p`
  font-size: ${tokens.fontSize.medium};
  color: ${colors.darkGray};
  line-height: 2.14;
  a {
    color: ${tokens.colors.black6};
    font-weight: bold;
    &:hover {
      color: ${colors.darkGray};
    }
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const PresentationImage = styled.img`
  width: 100%;
  height: auto;
  animation: ${fadeIn} ease 0.3s;
  border-top-left-radius: 5px;
`

export const Footer = styled.div`
  padding: 24px;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  left: 0;
  background-color: ${tokens.colors.white};
  bottom: 0;
  border-top: solid 1px ${colors.lightGray};
  & > * {
    margin-left: 16px;
  }
  border-radius: 0 0 5px 5px;
`
